import PropTypes from 'prop-types';
import React from 'react';
import {
  createCustomPropType,
  isNonEmptyString,
  isNumeric,
} from '../../../../js/app/react/validators';
import AdvForm from '../../../CommonComponents/AdvForm';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';
import Navigation from '../../Navigation/NavigationContainer';
import SimpleSelect from '../../SimpleSelect/SimpleSelectView';
import Validation from '../../Validation/ValidationContainer';
import { BACKEND_KEY } from '../HealthcareWorkflowConstants';
import { startAtRetirementValidator } from '../HealthcareWorkflowValidator';

const StartAtRetirementView = ({
  workflowId,
  branch,
  clientId,
  startAtRetirement,
  updateStartAtRetirement,
  startYear,
  updateStartYear,
  isGoingForward,
  yearsOptions,
  estimateExpenses,
  annualExpense,
}) => {
  const selectedYear = yearsOptions.find(option => option && option.value === startYear);

  return (
    <AdvWorkflowStep
      branch={branch}
      workflowId={workflowId}
      id="StartAtRetirement"
      canSkip={isGoingForward && (startAtRetirement === true || startYear)}
    >
      <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.StartAtRetirement`} />

      <h2>When will your health care goal begin?</h2>

      <AdvForm>
        <ul className="horizontal school-list">
          <li className="school-item">
            <div onClick={() => updateStartAtRetirement(workflowId, clientId)(true)}>
              <div
                className={`school-item__button-radio-empty${
                  startAtRetirement === true ? ' selected' : ''
                }`}
              />
              <button type="button" className="school-item__button">
                At Retirement
              </button>
            </div>
          </li>
          <li className="school-item">
            <div onClick={() => updateStartAtRetirement(workflowId, clientId)(false)}>
              <div
                className={`school-item__button-radio-empty${
                  startAtRetirement === false ? ' selected' : ''
                }`}
              />
              <button type="button" className="school-item__button">
                Specific Year
              </button>
            </div>
          </li>
          <li
            className={`school-item school-item__select ${
              startAtRetirement !== false ? 'school-item--hidden' : ''
            }`}
          >
            <SimpleSelect
              className="no-horizontal-scroll sm"
              id="healthcare-year"
              onValueChange={updateStartYear(workflowId, clientId)}
              value={selectedYear}
              options={yearsOptions}
            />
          </li>
        </ul>
      </AdvForm>

      <Navigation
        nextIterators={[]}
        dirtyGraphNodes={[]}
        validator={startAtRetirementValidator(startAtRetirement, startYear)}
        validationId={`${BACKEND_KEY}.StartAtRetirement`}
        workflowId={workflowId}
        backendKey={BACKEND_KEY}
        doNotSave={estimateExpenses !== true && !annualExpense}
        validatedOnClick={() =>
          workflowAnalyticsEvents(workflowId, 'healthcare_start_date_completed')
        }
      />
    </AdvWorkflowStep>
  );
};

StartAtRetirementView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  healthcareGoal: PropTypes.shape({
    StartAtRetirement: PropTypes.bool,
    StartYear: PropTypes.number,
  }).isRequired,
  startAtRetirement: PropTypes.bool.isRequired,
  startYear: PropTypes.number.isRequired,
  updateStartYear: PropTypes.func.isRequired,
  updateStartAtRetirement: PropTypes.func.isRequired,
  isGoingForward: PropTypes.bool.isRequired,
  yearsOptions: PropTypes.arrayOf({
    label: PropTypes.string,
    value: PropTypes.number,
  }).isRequired,
  estimateExpenses: PropTypes.bool.isRequired,
  annualExpense: PropTypes.number.isRequired,
};

export default StartAtRetirementView;
